import { useFlags } from "launchdarkly-react-client-sdk"
import { useLocation } from "react-router-dom"
import queryString from "query-string"

export const usePreloginEnabled = (): boolean => {
  const { preLoginEndpoint } = useFlags()
  const { search } = useLocation()
  const ffPrelogin = queryString.parse(search).ff_prelogin
  const ffPreloginValue = Array.isArray(ffPrelogin) ? ffPrelogin[0] : ffPrelogin

  return Boolean(preLoginEndpoint) || ffPreloginValue === "1"
}
